import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { numberFormatter } from "@ecommerce/shared-utils";
import { AppConfigFields } from "../../types/appConfigEntities";




const DEFAULT_DISCOUNTS = window.APP_CONFIG?.[AppConfigFields.Discounts] ?? [
    { percent: "10% OFF", threshold: "$600.000" },
    { percent: "15% OFF", threshold: "$1.500.000" },
    { percent: "20% OFF", threshold: "$2.000.000" },
];

export const MinimumBuyBanner: React.FC = () => {
    const minimumPurchase = window.APP_CONFIG?.[AppConfigFields.MinimumPurchaseAmount];

    const discountsText = DEFAULT_DISCOUNTS
        .map(d => `${d.percent} +${d.threshold}`)
        .join(" · ");

    return (
        <Box
            id="top-banner"
            bgcolor="#0101014D"
            color="white"
            textAlign="center"
            py={0.5}
            fontSize="0.875rem"
            position="fixed"
            top={0}
            left={0}
            right={0}
            zIndex={1400}
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                px: 1,
                flexWrap: "wrap",
            }}
        >
            <Typography
                variant="body2"
                fontSize="inherit"
                sx={{
                    fontFamily: '"Rubik", sans-serif',
                    color: "white",
                    lineHeight: 1.3,
                    textAlign: "center",
                }}
            >
                {`Compra Mínima ${numberFormatter.toStringWithAmount(minimumPurchase, "$", 0)} // `}
                <Box component="span" >
                    {discountsText}
                </Box>
            </Typography>
        </Box>
    );
};














